import React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';

// Fullscreen, zoomable single-image viewer used for poster/photo previews
// across the *ViewX* detail pages, replacing the old plain <img> in an antd
// Modal (no zoom, no pan, fixed small size).
const ImageLightbox = ({ open, onClose, src, title }) => {
    if (!src) return null;

    return (
        <Lightbox
            open={open}
            close={onClose}
            slides={[{ src, title }]}
            plugins={[Zoom, Captions]}
            zoom={{ maxZoomPixelRatio: 10, scrollToZoom: true }}
            carousel={{ finite: true }}
            controller={{ closeOnBackdropClick: true }}
        />
    );
};

export default ImageLightbox;
